<template>
  <div>
    <div class="row">
     <div class="input-field col s12 m6 l6 xl6">
          <input id="nome" @input="verifyNome()" name="nome" required type="text"
          class="validate" v-model='atua.nome'>
          <label for="nome">Nome </label>
      </div>
      <div class="input-field col s12 m6 l6 xl6">
            <select name="tipo" id="tipo"  required class="browser-default select_sec">
                <option value="" selected disabled>Tipo de Atuações</option>
                <!--option value="SIAC" :selected="this.tipo == 'SIAC'" v-if="!this.atua.id || this.tipo == 'SIAC'">SIAC</option-->
                <option value="ATGV" :selected="tipo == 'ATGV'">Atuação em territórios e/ou grupos vulneráveis</option><!--Atuação em territórios e/ou grupos vulneráveis-->
                <!--option value="artístico-cultural" :selected="this.tipo == 'artístico-cultural'">artístico-cultural</option>
				<option value="produção científica" :selected="this.tipo == 'produção científica'">produção científica</option-->
			</select>

      </div>
       <div class="input-field col s6 m6 l3 xl3">
        <button  type="submit" class="btn">
          <i v-if="!this.atua.id" class="material-icons left">
            save
          </i>

          <i v-else class="material-icons left ">
            edit
          </i>
          <span v-if="!this.atua.id">
            Salvar
          </span>
          <span v-else>
            Atualizar
          </span>
        </button>
      </div>
     <div class="input-field col s6 m6 l3 xl3">
        <button  type="reset" class="btn indigo" @click="clear">
          <i class="material-icons right">clear</i>
          Limpar</button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueAtuacaoForm",
      props: [
        'atuacao'
      ],
      data () {
        return {
          atua:JSON.parse(this.atuacao),
          tipo:JSON.parse(this.atuacao).tipo,
        }
      },
      methods: {
        verifyNome () {
          this.verifyNomeLength()
        },
        clear (ev, nomeInput = '') {
          this.atua = {
            tipo:'',
            nome: nomeInput,
            id: null,
          }
        },
        verifyNomeLength() {
          if (this.atua.nome.length <= 100)
            this.nomeLength = true
          else
            this.nomeLength = false
        },

      },
      ready () {

      }
    }

</script>
